/**
 * GraphQL Queries for Infinite Scroll
 * Storefront API 2025-10
 */

const GraphQLQueries = {
  /**
   * Collection Products Query
   * Fetches products with pagination, sorting, and filtering
   * Includes filters field to calculate total count
   */
  COLLECTION_PRODUCTS: `
    query CollectionProducts(
      $handle: String!,
      $first: Int!,
      $after: String,
      $sortKey: ProductCollectionSortKeys,
      $reverse: Boolean,
      $filters: [ProductFilter!]
    ) {
      collection(handle: $handle) {
        id
        title
        products(
          first: $first,
          after: $after,
          sortKey: $sortKey,
          reverse: $reverse,
          filters: $filters
        ) {
          filters {
            id
            label
            type
            values {
              id
              label
              count
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            id
            handle
            title
            availableForSale
            vendor
            featuredImage {
              url(transform: { maxWidth: 600, maxHeight: 600 })
              altText
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            variants(first: 1) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }
  `,

  /**
   * Collection Info Query
   * Quick query to get collection metadata without products
   */
  COLLECTION_INFO: `
    query CollectionInfo($handle: String!) {
      collection(handle: $handle) {
        id
        title
        description
      }
    }
  `,

  /**
   * Products by IDs Query
   * Fetch specific products by their IDs (useful for recommendations)
   */
  PRODUCTS_BY_IDS: `
    query ProductsByIds($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          handle
          title
          availableForSale
          vendor
          featuredImage {
            url(transform: { maxWidth: 600, maxHeight: 600 })
            altText
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  `,

  /**
   * Product Recommendations Query
   * Note: Shopify's productRecommendations doesn't support pagination
   * Returns up to 10 recommendations by default
   */
  PRODUCT_RECOMMENDATIONS: `
    query ProductRecommendations($productId: ID!) {
      productRecommendations(productId: $productId) {
        id
        handle
        title
        availableForSale
        vendor
        featuredImage {
          url(transform: { maxWidth: 600, maxHeight: 600 })
          altText
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        variants(first: 1) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `,
};

// Export for module usage
if (typeof module !== "undefined" && module.exports) {
  module.exports = GraphQLQueries;
}
